export default "__VITE_ASSET__e8b4b8f3__"